import { Controller } from "@hotwired/stimulus"

export class PrettyJsonController extends Controller {
    connect() {
        try { this.element.textContent = JSON.stringify(JSON.parse(this.element.textContent), null, 2) }
        catch { /* Keep the original escaped text when an older snapshot is malformed. */ }
    }
}
